<template>
  <v-list class="transparent">
    <template v-if="computedLine.scheme !== 'flat'">
      <v-list-item v-for="(b, i) in computedLine.breakdown" :key="i">
          <v-list-item-title>
          <span class="text--secondary font-weight-medium">{{b.tierQuantity}} x {{b.tierAmount | currency(currency)}} {{currency}}</span>
          </v-list-item-title>
          <v-list-item-subtitle class="text-right text--primary">{{b.tierTotal | currency(currency)}} {{currency}}</v-list-item-subtitle>
      </v-list-item>
      <v-divider class="ma-4" />
    </template>

    <v-list-item v-if="computedLine.discount">
      <v-list-item-title class="text--secondary font-weight-medium">Descuento</v-list-item-title>
      <v-list-item-subtitle class="text-right text--primary">{{computedLine.discount | currency(currency)}} {{currency}}</v-list-item-subtitle>
    </v-list-item>

    <v-list-item>
      <!-- <template v-if="!plan.exempt">+ impuestos</template> -->
      <v-list-item-title class="text--secondary font-weight-medium">Total</v-list-item-title>
      <v-list-item-subtitle class="text-right text--primary">{{computedLine.total | currency(currency)}} {{currency}}</v-list-item-subtitle>
    </v-list-item>
  </v-list>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  props: {
    computedLine: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  mixins: [
    GenericViewMixin
  ]
}
</script>